export default __webpack_public_path__ + "f4ee6abf54b5ea2a0943d81ab2ecc271.webp";